export class ProjectDataUnity {
	public ml: number;
	public mlStr: string = "";
	public elementos: any[] = [];
	public cantidadComodines?: number;
	public cantidadComodines_des?: number;
	public cantidadBayonetas?: number;
	public canvas2DSize?: any; //{ "X" : number, "Y" : number }
	public cerrado: boolean;
	public topEdgeCut?: number;

	constructor() {
		//	this.canvas2DSize = { "X" : 200, "Y" : 100 };
	}
}
